import React, { useState, useEffect, useRef } from 'react';
import { Typography, Statistic  } from 'antd';
import { Row, Col } from 'antd';
import axios from 'axios';
import './Home.css'; // CSS 파일을 import합니다.
const { Title, Paragraph, } = Typography;


const Home = () => {
  useEffect(() => {
  }, [])

  const [totVisit, setTotVisit] = React.useState('');

  React.useEffect(() => {
    axios.get("/api/v1/visit").then((response) => {
      //console.log(response.data);
      if (response.data.status === 0) {
      }
      setTotVisit(response.data.data);
    }).catch(function (error) {

      setTotVisit([]);
      
      if (error.response) {
        // 요청이 전송되었고, 서버는 2xx 외의 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 전송되었지만, 응답이 수신되지 않았습니다. 
        // 'error.request'는 브라우저에서 XMLHtpRequest 인스턴스이고,
        // node.js에서는 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류가 발생한 요청을 설정하는 동안 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    });

  }, []);

  return (
    <div>
      <Row justify="center">
        <Col xs={24} sm={24} md={20} lg={20} xl={20}>
          <h2>VoLab Home Page</h2>
          <br/> 
          
          <Typography>
            <Paragraph>
              volab.kr 은 개인적으로 스터디 목적을 위해 만들어진 사이트입니다. 주제는 딱히 없으며 주로 주식이나 업무 또는 취미에 관련된 것들입니다.<br></br>
              개인적인 목적으로 관리하기 때문에 사이트는 조금씩 변경이 있을 수도 있으나 아예 사라지지거나 하는 일은 없을 것입니다.<br></br>
              또한 이 사이트가 여러분들에게 조금이나마 도움이 되길 바래봅니다.<br></br>
            </Paragraph>
            <Title level={4}>주제.</Title>
            <Paragraph>
            <ul>
              <li>
              <Title level={5}> 네이버 판매 왕</Title>
              <Paragraph>네이버 검색어 트랜드의 인기 키워드를 분석하여 키워드에 대한 스토어의 상품수 정보를 제공합니다.&nbsp; <a href='/nepanking'>[바로가기]</a><br></br>
              안드로이드 및 아이폰 앱 전용 버전으로도 이용할 수 있습니다.&nbsp;
                <a href='https://play.google.com/store/apps/details?id=com.ccassak.nepanking&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                  <img alt='Get it on Google Play' src='/google-play-badge-small.png'/>
                </a>
                <a href='http://apps.apple.com/kr/app/nepanking/id6468895837?itsct=apps_box_link&itscg=30200'>
                  <img alt='Download on the App Store' src='/app-store-badge-small.svg'/>
                </a>
              </Paragraph>
              </li>
              <li>
              <Title level={5}> Snmp Mib Finder</Title>
              <Paragraph>주어진 Vendor Number 또는 밴더명으로 SNMP MIB 정보를 찾습니다.&nbsp; <a href='/mib'>[바로가기]</a></Paragraph>
              </li>
              <br />
              <li>
              <Title level={5}>NIC Vendor Finder</Title>
              <Paragraph>주어진 OUI 또는 맥주소로 NIC 제조사를 찾습니다.&nbsp; <a href='/nic'>[바로가기]</a></Paragraph>
              </li>
              <br />
              <li>
              <Title level={5}>Auto ETrade Hist</Title>
              <Paragraph>이벤스트 증권에서 제공하는 Xing API를 통해 자동매매한 이력정보를 확인합니다.&nbsp; <a href='/etrade'>[바로가기]</a></Paragraph>
              </li>
              <br />
              <li>
              <Title level={5}>World Salsa Feistival</Title>
              <Paragraph>전 세계에서 펼쳐지는 라틴댄스 축제에 대한 일정 정보를 제공합니다.&nbsp; <a href='/wsf'>[바로가기]</a><br></br>
              안드로이드 및 아이폰 앱 전용 버전으로도 이용할 수 있습니다.&nbsp;
                <a href='https://play.google.com/store/apps/details?id=com.ccassak.wsf&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                  <img alt='Get it on Google Play' src='/google-play-badge-small.png'/>
                </a>
                <a href='https://apps.apple.com/us/app/world-salsa-festival/id1628543187?itsct=apps_box_link&itscg=30200'>
                  <img alt='Download on the App Store' src='/app-store-badge-small.svg'/>
                </a>
              </Paragraph>
              </li>
              <li>
              <Title level={5}>K-Salsa Event</Title>
              <Paragraph>국내 전국의 동호회,클럽,아카데미 등에서 열리는 라틴댄스 이벤트에 대한 일정 정보를 제공합니다.&nbsp; <a href='/k-salsa'>[바로가기]</a><br></br>
              안드로이드 및 아이폰 앱 전용 버전으로도 이용할 수 있습니다.&nbsp;
                <a href='https://play.google.com/store/apps/details?id=com.ccassak.wsf&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                  <img alt='Get it on Google Play' src='/google-play-badge-small.png'/>
                </a>
                <a href='https://apps.apple.com/us/app/world-salsa-festival/id1628543187?itsct=apps_box_link&itscg=30200'>
                  <img alt='Download on the App Store' src='/app-store-badge-small.svg'/>
                </a>
              </Paragraph>
              </li>
            </ul>
            </Paragraph>
          </Typography>
        </Col>
        <Col>
        <Statistic title="현재까지 총 방문자 수" value={totVisit} />
        <br/>
        </Col>
        
      </Row>
    </div>
  );
}

export default Home;